import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import api from '~/api';
import { useToast } from '~/hooks/useToast';
import { useUser } from '~/providers/UserProvider';

// grants belong to the login, not the store, so the key is the user
const useQueryKey = () => {
  const { idFromPlatform } = useUser();
  return ['mcpIdentityGrants', idFromPlatform] as const;
};

export const useMcpIdentityGrantList = ({ enabled }: { enabled: boolean }) => {
  const { idFromPlatform } = useUser();
  const queryKey = useQueryKey();

  return useQuery({
    queryKey,
    queryFn: () => api.user.mcpIdentityGrant.list(idFromPlatform),
    enabled,
  });
};

export const useMcpIdentityGrantDelete = () => {
  const { idFromPlatform } = useUser();
  const queryKey = useQueryKey();
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation({
    mutationFn: (identityGrantId: number) =>
      api.user.mcpIdentityGrant.delete(idFromPlatform, `${identityGrantId}`),
    onSuccess: () => {
      toast.show('Connection revoked');
      return queryClient.invalidateQueries({ queryKey });
    },
    onError: () => {
      toast.show('Failed to revoke connection');
    },
  });
};
